import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { dateOrNull, nullableString } from '../utils/wire-value-utils';

/**
 * An ADN chemical sponsor, built from `/admin/sponsors` JSON (hub `data-models/sponsor.ts`).
 *
 * Read-modify-write rule: writable fields the hub didn't send stay `undefined` (an explicit `null` stays
 * `null`). Display fallbacks belong in templates.
 */
export class Sponsor extends Base {
  // Writable via POST / PUT /admin/sponsors (the controller's body)
  name?: string | null;
  logoUrl?: string | null;
  website?: string | null;
  phone?: string | null;
  email?: string | null;
  brandColor?: string | null;
  description?: string | null;
  /** `locations_only`, `reps_only`, `mixed` or `contact_form_only`. */
  contactType?: string | null;
  contactMessage?: string | null;

  // Read-only
  archivedAt: Date | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.name = nullableString(source['name']);
    this.logoUrl = nullableString(source['logoUrl']);
    this.website = nullableString(source['website']);
    this.phone = nullableString(source['phone']);
    this.email = nullableString(source['email']);
    this.brandColor = nullableString(source['brandColor']);
    this.description = nullableString(source['description']);
    this.contactType = nullableString(source['contactType']);
    this.contactMessage = nullableString(source['contactMessage']);
    this.archivedAt = dateOrNull(source['archivedAt']);
  }
}
